import axios from '@fs/zion-axios'
import { sgBaseUrl } from '@fs/zion-config'
import { apiRequest } from '../MemoryBooksAPI/memoryBooksAPI'

/**
 * Fetches a PDF fan chart from FamilySearch API and returns as arraybuffer
 * @param {Object} params - Fan chart parameters
 * @param {string} params.personId - Tree person ID (e.g., 'KWNR-N6K')
 * @param {string} [params.locale='en'] - Language locale
 * @param {string} [params.view='FAMILY_LINES'] - Fan chart view type
 * @param {number} [params.numGenerations=6] - Number of generations to display
 * @param {Function} [params.onSuccess] - Success callback
 * @param {Function} [params.onError] - Error callback
 * @param {Function} [params.onStart] - Start callback
 * @param {Function} [params.onComplete] - Complete callback
 * @returns {Promise<{status: number|null, error: Error|null, response: Object|null}>}
 */
export const fetchFanChartPDF = async ({
  personId,
  locale = 'en',
  view = 'FAMILY_LINES',
  numGenerations = 6,
  onSuccess,
  onError,
  onStart,
  onComplete,
}) => {
  if (!personId) {
    const error = new Error('personId is required to fetch fan chart')
    console.error(error)
    if (onError) onError(error)
    return { status: null, error, response: null }
  }

  const { status, error, response } = await apiRequest({
    apiFunction: async () => {
      const url = `${sgBaseUrl}/service/tree/tree-data/pdf/fan-chart/${personId}`
      return axios.get(url, {
        params: {
          locale,
          view,
          numGenerations,
        },
        responseType: 'arraybuffer',
      })
    },
    onStart,
    onSuccess,
    onError,
    onComplete,
  })

  return { status, error, response }
}
